{
  "colorSwatchPicker": "Χρωματικά δείγματα",
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Επιλέξτε ένα αντικείμενο",
  "tableResizer": "Αλλαγή μεγέθους"
}
